import React from 'react';
import ActionButtonBase from '@material-ui/core/Fab';

const ActionButton = (props) => <ActionButtonBase {...props} />;

export default ActionButton;
